import React, {useState} from 'react';
import block from 'bem-cn-lite';
import './ArticleInfo.scss';
import {ArticleInfoModel} from '.';
import {Text, Tooltip} from '@gravity-ui/uikit';
import {useMediaQuery} from 'react-responsive';

const b = block('article-info');

interface ArticleInfoProps {
    className?: string;
    header: ArticleInfoModel;
    isCustomOrder?: boolean;
    isCustomOrderPopup?: boolean;
}

export const ArticleInfo: React.FC<ArticleInfoProps> = ({
    className,
    header,
    isCustomOrder,
    isCustomOrderPopup
}) => {
    const isMobileScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const [openTooltip, setOpenTooltip] = useState(false);

    return (
        <div
            className={`${b('item-header', className)} ${isCustomOrder ? b('item-header', 'custom-order') : ''}`}
        >
            {isCustomOrder ? (
                <>
                    {isMobileScreen && !isCustomOrderPopup ? (
                        <>
                            <Text
                                variant={'body-2'}
                                color={'complementary'}
                                className={b('article-name')}
                            >
                                {header.articleName}
                            </Text>
                            <div className={b('mobile-row')}>
                                <Text
                                    variant={'body-2'}
                                    color={'misc-heavy'}
                                    className={b('article')}
                                >
                                    {header.article}
                                </Text>
                                <Text
                                    variant={'body-2'}
                                    className={b('brand-name')}
                                    translate={'no'}
                                >
                                    {header.brandName}
                                </Text>
                            </div>
                        </>
                    ) : (
                        <>
                            <Text variant={'body-2'} className={b('article-name')}>
                                {header.articleName}
                            </Text>
                            <Text
                                variant={'body-2'}
                                color={'complementary'}
                                className={b('brand-name')}
                                translate={'no'}
                            >
                                {header.brandName}
                            </Text>
                            <Tooltip
                                content={
                                    <Text variant={'body-1'} className={b('tooltip-content')}>
                                        Скопировано
                                    </Text>
                                }
                                placement="top-start"
                                contentClassName={b('tooltip')}
                                className={b('tooltip-container')}
                                openDelay={0}
                                disabled={!openTooltip}
                            >
                                <div
                                    className={b('copy')}
                                    onClick={() => {
                                        setOpenTooltip(true);
                                        navigator.clipboard.writeText(header.article);
                                        setTimeout(() => setOpenTooltip(false), 3000);
                                    }}
                                >
                                    <Text
                                        variant={'body-2'}
                                        color={'misc-heavy'}
                                        className={b('article')}
                                    >
                                        {header.article}
                                    </Text>
                                </div>
                            </Tooltip>
                        </>
                    )}
                </>
            ) : (
                <>
                    <Text variant={'body-2'} className={b('brand-name')} translate={'no'}>
                        {header.brandName}
                    </Text>
                    <Tooltip
                        content={
                            <Text variant={'body-1'} className={b('tooltip-content')}>
                                Скопировано
                            </Text>
                        }
                        placement="top-start"
                        contentClassName={b('tooltip')}
                        className={b('tooltip-container')}
                        openDelay={0}
                        disabled={!openTooltip}
                    >
                        <div
                            className={b('copy')}
                            onClick={() => {
                                setOpenTooltip(true);
                                navigator.clipboard.writeText(header.article);
                                setTimeout(() => setOpenTooltip(false), 3000);
                            }}
                        >
                            <Text variant={'body-2'} color={'misc-heavy'} className={b('article')}>
                                {header.article}
                            </Text>
                        </div>
                    </Tooltip>
                    <div className={b('break')}></div>
                    <Text variant={'body-2'} color={'complementary'} className={b('article-name')}>
                        {header.articleName}
                    </Text>
                </>
            )}
        </div>
    );
};
